export enum DesignSystemPreview {
	BrandLift2025_Ignore_AB_TEST = "BrandLift2025_Ignore_AB_TEST",
}

export const toPrefixedClassName = (previewType: DesignSystemPreview) => `designSystemPreview_${previewType}`;
